// Export Property Namespace
export * as Property from '../Property.js';
export * from '../Models/Language.js';
export * from '../Models/LanguageList.js';
export * from '../Models/Website.js';
export * from '../Models/WebsiteList.js';
export * from '../Models/ContentLink.js';

// IContent
import * as IContentNS from '../Models/IContent.js';
export type IContent = IContentNS.default
export type IContentType = IContentNS.IContentType;
export const AbstractIContent = IContentNS.BaseIContent;
export const namePropertyIsString = IContentNS.namePropertyIsString